// extracted by mini-css-extract-plugin
export default {"wrapper":"Wga","container":"Xga","title":"Yga","desc":"Zga","usage":"aha","box":"bha","subtitle":"cha","ingredients":"eha","carousel":"fha","ingredientscarousel":"gha","productinfo":"hha","ingredientsinfo":"iha"};
    if(module.hot) {
      // 1738836199282
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  